import "./Failed.scss";
import { useState, useEffect } from "react";
import FailedGif from "./../../assets/images/failed.gif";
import { useLanguage } from "./../../context/LanguageContext";

const Failed = () => {
  const { t } = useLanguage(); // Get the translation function
  const [countdown, setCountdown] = useState(5);
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => prevCountdown - 1);
    }, 1000);

    if (countdown <= 0) {
      clearInterval(timer);
      window.location.href = "/";
    }

    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <div className="failed">
      <div className="message__container">
        <img src={FailedGif} alt={t("failedTransactionAlt")} />
        <h3>{t("purchaseFailed")}</h3>
        <h4>
          {t("redirectCountdownPrefix")}{" "}
          <span>
            {countdown} {t("seconds")}
          </span>
        </h4>
      </div>
    </div>
  );
};

export default Failed;
